<template>
  <div class="shopping-bag-container">
    <!-- Shopping Cart Here -->
    <ShoppingCart>
      <tfoot v-show="showPrices">
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td colspan="2" class="">
            <div class="cost-summary">
              <span class="total-text">Subtotal</span>
              <span class="cost-figure">{{ totalAmount }}</span>
            </div>
          </td>
          <!-- <td>Subtotal</td>
          <td class="text-left">
            <div class="">
              {{ totalAmount }}
            </div>
          </td> -->
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td colspan="2" class="text-left">
            <div class="cost-summary">
              <span class="total-text">Shipping</span>
              <span class="cost-figure">TBD</span>
              <!-- <span class="cost-figure shipping-method"
                >(USPS Priority Mail)</span
              > -->
            </div>
          </td>
          <!-- <td>Shipping</td>
          <td class="text-left">
            <div class="">
              TBD
            </div>
          </td> -->
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td colspan="2" class="text-left">
            <div class="total-box">
              <span class="total-text">Total</span>
              <span class="cost-figure">TBD</span>
            </div>
          </td>
          <td></td>
        </tr>
      </tfoot>
    </ShoppingCart>
    <div class="divider"></div>

    <div
      class="flex align-center justify-center"
      v-if="shoppingBagProducts.length"
    >
      <router-link
        :to="{ name: 'AddRecipient' }"
        tag="button"
        class="button-gemnote button-gemnote--small"
        >Next</router-link
      >
    </div>
  </div>
</template>

<script>
import { bus } from '../../main'
import ShoppingCart from './ShoppingCart'
import { mapState } from 'vuex'
import Util from '../../mixins/Util'
import { isCard } from '@/helpers'

export default {
  name: 'ShoppingBagList',
  mixins: [Util],
  components: { ShoppingCart },

  computed: {
    ...mapState({
      shoppingBagProducts: state => state.order.shoppingBagProducts
    }),
    totalAmount() {
      let total = 0
      if (!this.shoppingBagProducts) {
        return this.formatCurrency(0)
      } else {
        this.shoppingBagProducts.forEach(
          product =>
            (total +=
              parseInt(product.quantity) *
              parseFloat(
                product.type == 'product' || !product.type
                  ? product.selectedVariant.price
                  : product.bundle_attributes.lowestPrice
              ))
        )
      }
      return this.formatCurrency(total)
    },

    showPrices() {
      return this.$store.getters['team/showPrices']
    }
  },

  mounted() {
    this.removeCard()
  },

  methods: {
    removeCard() {
      bus.$on('removeCard', () => {
        let card = this.shoppingBagProducts.filter(
          product =>
            product && product.attributes && isCard(product.attributes.tagList)
        )

        if (card.length) {
          for (let i = 0; i <= card.length; i++) {
            this.removeItem(card[i])

            if (i == 0) {
              return
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.shopping-bag-container {
  margin-top: 2.5rem;
  h5 {
    font-size: 18px;
  }
  .divider {
    padding-bottom: 1rem;
    border-bottom: 1px solid #dfdad2;
  }
}

.button-gemnote--small {
  height: 3rem !important;
  padding: 0.5rem 2rem !important;
  margin-top: 3rem;
}

.total {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

.total-amount {
  padding-left: 2rem;
  align-items: flex-start;
}
@media (max-width: 998px) {
  .total-amount {
    padding-left: 0rem;
  }
}
</style>
